import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { IMAGES } from '../../data/images';

export default function Logo() {
  return (
    <Link to="/">
      <motion.div
        whileHover={{ scale: 1.05 }}
        className="relative group"
      >
        <div className="absolute inset-0 bg-red-600/20 rounded-xl blur-xl group-hover:bg-red-600/30 transition-colors" />
        <img
          src={IMAGES.hero.logo}
          alt="Benny's Pølsevogn"
          className="h-16 w-auto relative"
        />
      </motion.div>
    </Link>
  );
}